/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup'
import i18n from '../../../i18n'
import { VALIDATION } from '../../../utils/translation-constants'

export const SuggestionSchema = Yup.object().shape({
  feedback: Yup.string()
    .min(10, i18n.t(VALIDATION.FEEDBACKVALID))
    .max(150, i18n.t(VALIDATION.FEEDBACKVALID))
    .required(i18n.t(VALIDATION.FEEDBACK)),
  feedbackCategory: Yup.string()
    .required(i18n.t(VALIDATION.FEEDBACKCATEGORY)),
})

export const ServiceRequestSchema = Yup.object().shape({
  suggestion: Yup.string()
    .min(1, 'Please enter suggestion')
    .required('Suggestion is required'),
    category: Yup.string()
    .required('Category is required'),
})